var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArchCategoryMigrationTransfer16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture-Category/16/Migration-Transfer_16") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linear-gradient-aws/Category-Icons/Arch-Category_16/Arch-Category_Migration-Transfer_16.svg"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#055F4E",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56C0A7",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture-Category/16/Migration-Transfer_16",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linear-gradient-aws/Category-Icons/Arch-Category_16/Arch-Category_Migration-Transfer_16.svg)",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    id: "#879196-Border-Copy-17",
    stroke: "#879196",
    strokeWidth: 2,
    x: 1,
    y: 1,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Category/16/Migration-Transfer_16",
    transform: "translate(8.000000, 8.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.387,11.5 L8.5,8.252 L5.614,11.5 L7,11.5 C7.277,11.5 7.5,11.724 7.5,12 L7.5,14.5 L9.5,14.5 L9.5,12 C9.5,11.724 9.724,11.5 10,11.5 L11.387,11.5 Z M12.874,11.668 C13.005,11.815 13.037,12.025 12.956,12.205 C12.875,12.384 12.698,12.5 12.5,12.5 L10.5,12.5 L10.5,15 C10.5,15.276 10.277,15.5 10,15.5 L7,15.5 C6.724,15.5 6.5,15.276 6.5,15 L6.5,12.5 L4.5,12.5 C4.303,12.5 4.125,12.384 4.044,12.205 C3.963,12.025 3.995,11.815 4.126,11.668 L8.126,7.168 C8.316,6.954 8.685,6.954 8.874,7.168 L12.874,11.668 Z M16,7.207 C16,9.115 14.861,10.5 13.289,10.5 L13.289,9.5 C14.465,9.5 15,8.312 15,7.207 C15,6.359 14.454,5.454 12.921,5.454 C12.767,5.454 12.622,5.383 12.527,5.261 C12.432,5.14 12.399,4.982 12.436,4.833 C12.57,4.297 12.463,3.808 12.144,3.491 C11.832,3.183 11.358,3.083 10.845,3.216 C10.718,3.251 10.58,3.231 10.465,3.163 C10.351,3.095 10.268,2.984 10.236,2.856 C9.917,1.607 9.029,1 7.518,1 C7.218,1.002 4.579,1.121 4.579,4.547 C4.579,4.824 4.356,5.047 4.079,5.047 C2.076,5.047 2.002,6.9 2,7.111 C2,8.229 2.812,9.476 3.976,9.476 L3.976,10.476 C2.196,10.476 1,8.735 1,7.109 C1,6.125 1.557,4.323 3.594,4.076 C3.675,2.849 4.077,1.867 4.794,1.152 C5.933,0.015 7.443,0 7.518,0 L7.519,0 C9.712,0 10.662,1.094 11.066,2.167 C11.754,2.105 12.384,2.322 12.848,2.781 C13.287,3.217 13.512,3.829 13.49,4.489 C15.219,4.713 16,5.965 16,7.207 L16,7.207 Z",
    id: "Migration-Transfer_Category-Icon_16_Squid"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchCategoryMigrationTransfer16);
export default __webpack_public_path__ + "static/media/Arch-Category_Migration-Transfer_16.7ff345ea9ca57a0950f465a6258ab3d1.svg";
export { ForwardRef as ReactComponent };